<template>
  <main class="staff-page">
    <header class="page-heading">
      <div>
        <div class="page-eyebrow">Каталог</div>
        <h1>Продукты</h1>
      </div>
    </header>
    <product-list />
  </main>
</template>

<script setup lang="ts">
import ProductList from '@/components/ProductList.vue';
</script>
